var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8222_17139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 0C3.14018 0 0 3.14018 0 6.99997C0 10.8598 3.14018 13.9999 7.00003 13.9999C10.8598 13.9999 14 10.8598 14 6.99997C14 3.14018 10.8598 0 7.00003 0ZM7.00003 13.2088C3.57647 13.2088 0.791244 10.4235 0.791244 6.99997C0.791244 3.57642 3.57647 0.791244 7.00003 0.791244C10.4235 0.791244 13.2088 3.57647 13.2088 6.99997C13.2088 10.4235 10.4235 13.2088 7.00003 13.2088Z",
    fill: "#4B5563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22152 3.85547H4.77859C4.26961 3.85547 3.85547 4.26961 3.85547 4.77859V9.22152C3.85547 9.73051 4.26961 10.1446 4.77859 10.1446H9.22152C9.73051 10.1446 10.1446 9.73051 10.1446 9.22152V4.77859C10.1446 4.26961 9.73051 3.85547 9.22152 3.85547ZM9.3534 9.22152C9.3534 9.293 9.293 9.3534 9.22152 9.3534H4.77859C4.70711 9.3534 4.64671 9.293 4.64671 9.22152V4.77859C4.64671 4.70711 4.70711 4.64671 4.77859 4.64671H9.22152C9.293 4.64671 9.3534 4.70711 9.3534 4.77859V9.22152Z",
    fill: "#4B5563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8222_17139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopButton);
export default __webpack_public_path__ + "static/media/stop-button.384b38605589b4ebcc12144296bdaa72.svg";
export { ForwardRef as ReactComponent };